import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function engagementAssignmentsReducer(
	state = initialState.engagementAssignments,
	action
) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_ASSIGNMENTS: {
			let engagementAssignments = action.response;
			return _.cloneDeep(engagementAssignments);
		}
		case types.CLEAR_ENGAGEMENT_ASSIGNMENTS: {
			return null;
		}
		case types.SAVE_ENGAGEMENT_ASSIGNMENT: {
			let assignments = _.cloneDeep(state);
			let newAssignment = action.response;
			// TODO: sort by name?
			if (newAssignment) {
				assignments.push({
					id: newAssignment.id,
					name: newAssignment.name
				});
			}
			return assignments;
		}
		default:
			return state;
	}
}
